import Header from "./components/Header/Header";
import Menu from "./components/Menu/Menu";
import Contact from "./components/Contact/Contact";
import Gallery from "./components/Gallery/Gallery";
// import Photos from "./components/Gallery/Photos";
import "./css/fonts.css";

function App() {
  return (
    <>
      <Header />
      <Gallery />
      <Menu />
      <Contact />
    </>
  );
}

export default App;
